/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Header } from '@mairistem/composants';

interface SectionHeaderProps {
  title: string;
  required?: boolean;
  style?: React.CSSProperties;
  /** Transmis au <Header> via `...rest`, aucun changement de corps nécessaire. */
  'data-testid'?: string;
}

const SectionHeader = (props: SectionHeaderProps) => {
  const { title, required, style, ...rest } = props;

  return (
    <Header as="h4" color="blue" style={style} {...rest}>
      <span style={{ textDecoration: 'underline' }}>{title}</span>
      {required && (
        <span style={{ color: '#96222a', marginLeft: '0.25em' }}>*</span>
      )}
    </Header>
  );
};

export default SectionHeader;
